import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { StoreContext } from '../context/StoreContext';

const ProtectedCheckoutRoute = ({ children }) => {
  const { user, guestVerified } = useContext(StoreContext);
  if (!user && !guestVerified) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedCheckoutRoute;
